var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('ConfirmPopup'),_vm._t("default",null,{"clicked":_vm.confirm})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }